/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const nestedAccountFeatureFlagNameMax = 255;

export const nestedAccountFeatureFlagCodeMax = 255;

export const NestedAccountFeatureFlag = zod.strictObject({
    name: zod.string().max(nestedAccountFeatureFlagNameMax),
    code: zod.string().max(nestedAccountFeatureFlagCodeMax),
});

export type NestedAccountFeatureFlag = zod.input<
    typeof NestedAccountFeatureFlag
>;
export type NestedAccountFeatureFlagOutput = zod.output<
    typeof NestedAccountFeatureFlag
>;
